import React, { ProviderProps } from 'react';

import noop from 'utils/noop';

import { HealthMonitorContext } from './context';

export function HealthMonitorProvider({ children }: ProviderProps<{}>) {
  const healthMonitor = {
    logHeartbeatEvent: noop
  };

  return (
    <HealthMonitorContext.Provider value={healthMonitor}>{children}</HealthMonitorContext.Provider>
  );
}
